export default {
  ru: {
    messages: {
      confirmed: () => 'Поля не совпадают',
      required: () => 'Поле обязательно для заполнения.',
      min: (val, arg) => `Поле должно содержать не менее ${arg} символов`,
      max: (val, arg) => `Поле должно содержать не более ${arg} символов`,
      length: (val, arg) => `Поле должно содержать 16 символов`, // add custom card length validatior
      alpha_spaces: (val) => `Поле может содержать только буквы и пробелы.`,
      alpha: (val) => `Поле может содержать только буквы.`,
      date_format: (val, arg) => `Дата должна быть в формате ##/##`,
      email: (val, arg) => `Неправильный формат почты`
    }
  }
}
